// import { Box } from '@chakra-ui/react';
// import useClickOutside from 'hooks/useClickOutside';
// import { isEmpty } from 'lodash';
// import { useState, useRef, useEffect } from 'react';
// import styled from 'styled-components';

// // Styled Components
// const Container = styled.div`
//     position: relative;
//     width: 100%;
// `;

// const Input = styled.input`
//     width: 100%;
//     padding: 10px;
//     border: 1px solid #ccc;
//     border-radius: 8px;
//     font-size: 14px;
//     outline: none;
//     &:focus {
//         border-color: #007bff;
//     }
// `;

// const MultiSelectContainer = styled.div`
//     width: 100%;
//     min-height: 42px;
//     padding: 6px 10px;
//     border: 1px solid #ccc;
//     border-radius: 8px;
//     font-size: 14px;
//     outline: none;
//     cursor: pointer;
//     display: flex;
//     flex-wrap: wrap;
//     align-items: center;
//     gap: 4px;
//     &:focus-within {
//         border-color: #007bff;
//     }
// `;

// const Tag = styled.div`
//     display: inline-flex;
//     align-items: center;
//     background: #e3f2fd;
//     border: 1px solid #90caf9;
//     border-radius: 16px;
//     padding: 2px 8px;
//     font-size: 12px;
//     color: #1976d2;
//     margin: 2px;
// `;

// const TagRemove = styled.button`
//     background: none;
//     border: none;
//     margin-left: 4px;
//     cursor: pointer;
//     color: #1976d2;
//     font-weight: bold;
//     padding: 0;
//     width: 16px;
//     height: 16px;
//     border-radius: 50%;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     &:hover {
//         background: #bbdefb;
//     }
// `;

// const Placeholder = styled.span`
//     color: #999;
//     font-size: 14px;
//     flex: 1;
// `;

// const Dropdown = styled.ul`
//     position: absolute;
//     top: 100%;
//     left: 0;
//     right: 0;
//     overflow-y: auto;
//     background: #fff;
//     border: 1px solid #ccc;
//     border-radius: 4px;
//     margin: 0;
//     padding: 0;
//     list-style: none;
//     z-index: 10;
//     padding-bottom: 16px;
//     box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
// `;

// const SearchInput = styled(Input)`
//     border: none;
//     border-bottom: 1px solid #ccc;
//     border-radius: 0;
//     margin: 0;
//     padding: 8px;
// `;

// const DropdownItem = styled.li`
//     padding: 10px;
//     cursor: pointer;
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     &:hover {
//         background: #f1f1f1;
//     }
//     ${(props) =>
//         props.selected &&
//         `
//         background: #e3f2fd;
//         color: #1976d2;
//     `}
// `;

// const Checkbox = styled.input`
//     margin-right: 8px;
// `;

// const ClearAllButton = styled.button`
//     background: none;
//     border: none;
//     color: #666;
//     cursor: pointer;
//     font-size: 12px;
//     padding: 4px 8px;
//     border-radius: 4px;
//     &:hover {
//         background: #f5f5f5;
//     }
// `;

// const SelectAllButton = styled.button`
//     background: none;
//     border: none;
//     color: #007bff;
//     cursor: pointer;
//     font-size: 12px;
//     padding: 4px 8px;
//     border-radius: 4px;
//     margin-left: 8px;
//     &:hover {
//         background: #e3f2fd;
//     }
// `;

// // SearchableSelect Component
// const SearchableSelect = ({
//     searchTerm,
//     setSearchTerm,
//     loading,
//     options,
//     onSelect,
//     value,
//     multiSelect = false,
//     placeholder = 'Select an option...',
//     searchPlaceholder = 'Search or select...',
//     maxHeight = '196px',
//     showSelectAll = true,
//     showClearAll = true,
// }) => {
//     const [isOpen, setIsOpen] = useState(false);
//     const [selectedOptions, setSelectedOptions] = useState([]);
//     const [selectedOption, setSelectedOption] = useState(null);
//     const dropdownRef = useRef(null);

//     useClickOutside(dropdownRef, () => setIsOpen(false));

//     // Helper function to get option display name
//     const getOptionName = (option) =>
//         option?.name || option?.company_name || option?.contact_name || '';

//     // Helper function to get option ID
//     const getOptionId = (option) =>
//         option?.item_id ||
//         option?.category_id ||
//         option?.brand_id ||
//         option?.contact_id ||
//         option?.id;

//     // Handle single select
//     const handleSingleSelect = (option) => {
//         setSelectedOption(option);
//         onSelect(option);
//         setIsOpen(false);
//         setSearchTerm && setSearchTerm('');
//     };

//     // Handle multiselect
//     const handleMultiSelect = (option) => {
//         const optionId = getOptionId(option);
//         const isSelected = selectedOptions.some((selected) => getOptionId(selected) === optionId);

//         let newSelectedOptions;
//         if (isSelected) {
//             newSelectedOptions = selectedOptions.filter(
//                 (selected) => getOptionId(selected) !== optionId,
//             );
//         } else {
//             newSelectedOptions = [...selectedOptions, option];
//         }

//         setSelectedOptions(newSelectedOptions);
//         onSelect(newSelectedOptions);
//         setSearchTerm && setSearchTerm('');
//     };

//     // Remove tag in multiselect
//     const removeTag = (optionToRemove, e) => {
//         e.stopPropagation();
//         const optionId = getOptionId(optionToRemove);
//         const newSelectedOptions = selectedOptions.filter(
//             (option) => getOptionId(option) !== optionId,
//         );
//         setSelectedOptions(newSelectedOptions);
//         onSelect(newSelectedOptions);
//     };

//     // Select all options
//     const handleSelectAll = () => {
//         if (!options || options.length === 0) return;
//         setSelectedOptions([...options]);
//         onSelect([...options]);
//     };

//     // Clear all selections
//     const handleClearAll = () => {
//         setSelectedOptions([]);
//         onSelect([]);
//     };

//     // Check if option is selected in multiselect
//     const isOptionSelected = (option) => {
//         if (!multiSelect) return false;
//         const optionId = getOptionId(option);
//         return selectedOptions.some((selected) => getOptionId(selected) === optionId);
//     };

//     // Update selections when value prop changes
//     useEffect(() => {
//         if (!isEmpty(options)) {
//             if (multiSelect && Array.isArray(value)) {
//                 const newSelectedOptions = value
//                     .map((val) => {
//                         if (typeof val === 'string') {
//                             return options?.find(
//                                 (option) =>
//                                     getOptionName(option) === val || getOptionId(option) === val,
//                             );
//                         }
//                         return val;
//                     })
//                     .filter(Boolean);
//                 setSelectedOptions(newSelectedOptions);
//             } else if (!multiSelect && typeof value === 'string') {
//                 const newOption = options?.find(
//                     (option) => getOptionName(option) === value || getOptionId(option) === value,
//                 );
//                 setSelectedOption(newOption);
//             }
//         }
//     }, [value, options, multiSelect]);

//     const renderSingleSelect = () => (
//         <Input
//             type="text"
//             readOnly
//             value={getOptionName(selectedOption)}
//             onClick={() => setIsOpen(!isOpen)}
//             placeholder={placeholder}
//         />
//     );

//     const renderMultiSelect = () => (
//         <MultiSelectContainer onClick={() => setIsOpen(!isOpen)}>
//             {selectedOptions.length > 0 ? (
//                 selectedOptions.map((option, index) => (
//                     <Tag key={`${getOptionId(option)}-${index}`}>
//                         {getOptionName(option)}
//                         <TagRemove onClick={(e) => removeTag(option, e)}>×</TagRemove>
//                     </Tag>
//                 ))
//             ) : (
//                 <Placeholder>{placeholder}</Placeholder>
//             )}
//         </MultiSelectContainer>
//     );

//     const renderDropdownActions = () => {
//         if (!multiSelect || !options || options.length === 0) return null;

//         return (
//             <Box
//                 display="flex"
//                 justifyContent="space-between"
//                 alignItems="center"
//                 px={2}
//                 py={1}
//                 borderBottom="1px solid #eee">
//                 <Box>
//                     {showSelectAll && (
//                         <SelectAllButton onClick={handleSelectAll} type="button">
//                             Select All ({options.length})
//                         </SelectAllButton>
//                     )}
//                 </Box>
//                 {showClearAll && selectedOptions.length > 0 && (
//                     <ClearAllButton onClick={handleClearAll} type="button">
//                         Clear All ({selectedOptions.length})
//                     </ClearAllButton>
//                 )}
//             </Box>
//         );
//     };

//     return (
//         <Container ref={dropdownRef}>
//             {multiSelect ? renderMultiSelect() : renderSingleSelect()}

//             {isOpen && (
//                 <Dropdown>
//                     {renderDropdownActions()}
//                     <Box maxH={maxHeight} overflowY={'auto'}>
//                         <SearchInput
//                             type="text"
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             placeholder={searchPlaceholder}
//                         />
//                         {options?.length > 0 ? (
//                             options?.map((option, index) => (
//                                 <DropdownItem
//                                     key={index}
//                                     selected={isOptionSelected(option)}
//                                     onClick={() =>
//                                         multiSelect
//                                             ? handleMultiSelect(option)
//                                             : handleSingleSelect(option)
//                                     }>
//                                     <div style={{ display: 'flex', alignItems: 'center' }}>
//                                         {multiSelect && (
//                                             <Checkbox
//                                                 type="checkbox"
//                                                 checked={isOptionSelected(option)}
//                                                 onChange={() => {}} // Handled by onClick
//                                             />
//                                         )}
//                                         {getOptionName(option)}
//                                     </div>
//                                 </DropdownItem>
//                             ))
//                         ) : (
//                             <DropdownItem>No options found</DropdownItem>
//                         )}
//                     </Box>
//                 </Dropdown>
//             )}
//         </Container>
//     );
// };

// export default SearchableSelect;

/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import {
    Box, Flex, Text, Input, Popover, PopoverTrigger, PopoverContent,
    PopoverBody, Portal, Spinner,
} from '@chakra-ui/react';

/* ─────────────────────────────────────────────────────────────
   BRAND TOKENS
   ───────────────────────────────────────────────────────────── */
const NAVY        = '#1B3B5F';
const CYAN        = '#DCF8F9';
const INK         = '#1A2740';
const MUTED       = '#5A6B7E';
const FAINT       = '#8896AE';
const SURFACE     = '#FFFFFF';
const SURFACE_ALT = '#F7F9FB';
const BORDER      = '#E8EDF5';
const BORDER_INPUT = '#DCE3EE';
const FONT        = "'Bricolage Grotesque', sans-serif";

/* ─────────────────────────────────────────────────────────────
   HELPERS
   ───────────────────────────────────────────────────────────── */
// const getOptionName = (option) =>
//     option?.name ?? option?.company_name ?? option?.contact_name ?? '';
const isUsefulName = (n) => {
    if (typeof n !== 'string') return false;
    const t = n.trim();
    if (!t) return false;
    if (t === 'undefined undefined') return false;
    if (t === 'null null') return false;
    return true;
};

const getOptionName = (option) => {
    const candidates = [
        option?.name,
        option?.contact_name,
        option?.company_name,
        option?.customer_name,
        option?.vendor_name,
        option?.first_name && option?.last_name
            ? `${option.first_name} ${option.last_name}`
            : null,
        option?.email,
    ];
    return candidates.find(isUsefulName) ?? '(Unnamed)';
};

const getOptionId = (option) =>
    option?.item_id ??
    option?.category_id ??
    option?.brand_id ??
    option?.contact_id ??
    option?.id ??
    null;

/* localStorage-backed recently used list, keyed per `name` so each
   instance (e.g. "customers", "vendors") has its own history. */
const RECENT_LIMIT = 5;
const recentKey = (name) => `searchable_select_recent::${name || 'default'}`;

const loadRecent = (name) => {
    try {
        const raw = localStorage.getItem(recentKey(name));
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
};

const saveRecent = (name, option) => {
    try {
        const id = getOptionId(option);
        if (!id) return;
        const current = loadRecent(name);
        /* Drop any prior occurrence then put at front, cap to RECENT_LIMIT */
        const next = [option, ...current.filter((o) => getOptionId(o) !== id)].slice(0, RECENT_LIMIT);
        localStorage.setItem(recentKey(name), JSON.stringify(next));
    } catch {
        /* localStorage might be unavailable (privacy mode, quota) — silently ignore */
    }
};

/* ─────────────────────────────────────────────────────────────
   SearchableSelect — drop-in replacement
   API kept compatible with prior version:
   - name, searchTerm, setSearchTerm, options, loading, onSelect
   - value, multiSelect, placeholder, searchPlaceholder
   - maxHeight, showSelectAll, showClearAll
   ───────────────────────────────────────────────────────────── */
const SearchableSelect = ({
    name,
    searchTerm,
    setSearchTerm,
    loading,
    options,
    onSelect,
    value,
    multiSelect = false,
    placeholder = 'Select an option...',
    searchPlaceholder = 'Search...',
    maxHeight = '280px',
    showSelectAll = true,
    showClearAll = true,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [highlightIdx, setHighlightIdx] = useState(0);
    const [recent, setRecent] = useState(() => loadRecent(name));

    const searchInputRef = useRef(null);
    const listRef        = useRef(null);

    /* ── Reset highlight when options change ───────────────── */
    useEffect(() => {
        setHighlightIdx(0);
    }, [options, searchTerm]);

    /* ── Focus search input on open ────────────────────────── */
    useEffect(() => {
        if (isOpen) {
            /* slight delay so the popover is mounted */
            const t = setTimeout(() => searchInputRef.current?.focus(), 50);
            return () => clearTimeout(t);
        }
    }, [isOpen]);

    /* ── Sync value -> selected (for controlled use) ───────── */
    useEffect(() => {
        if (!options || options.length === 0) return;

        if (multiSelect && Array.isArray(value)) {
            const matched = value
                .map((val) => {
                    if (typeof val === 'string') {
                        return options.find(
                            (o) => getOptionName(o) === val || getOptionId(o) === val
                        );
                    }
                    return val;
                })
                .filter(Boolean);
            setSelectedOptions(matched);
        } else if (!multiSelect && typeof value === 'string') {
            const match = options.find(
                (o) => getOptionName(o) === value || getOptionId(o) === value
            );
            if (match) setSelectedOption(match);
        }
    }, [value, options, multiSelect]);

    /* ── Selection handlers ─────────────────────────────────── */
    const handleSingleSelect = useCallback((option) => {
        setSelectedOption(option);
        onSelect?.(option);
        saveRecent(name, option);
        setRecent(loadRecent(name));
        setIsOpen(false);
        setSearchTerm?.('');
    }, [onSelect, name, setSearchTerm]);

    const handleMultiSelect = useCallback((option) => {
        const id = getOptionId(option);
        const isSelected = selectedOptions.some((o) => getOptionId(o) === id);
        const next = isSelected
            ? selectedOptions.filter((o) => getOptionId(o) !== id)
            : [...selectedOptions, option];
        setSelectedOptions(next);
        onSelect?.(next);
        saveRecent(name, option);
        setRecent(loadRecent(name));
    }, [selectedOptions, onSelect, name]);

    const removeTag = useCallback((option, e) => {
        e.stopPropagation();
        const id = getOptionId(option);
        const next = selectedOptions.filter((o) => getOptionId(o) !== id);
        setSelectedOptions(next);
        onSelect?.(next);
    }, [selectedOptions, onSelect]);

    const handleSelectAll = useCallback(() => {
        if (!options?.length) return;
        setSelectedOptions([...options]);
        onSelect?.([...options]);
    }, [options, onSelect]);

    const handleClearAll = useCallback(() => {
        setSelectedOptions([]);
        onSelect?.([]);
    }, [onSelect]);

    const isOptionSelected = useCallback((option) => {
        if (!multiSelect) return false;
        const id = getOptionId(option);
        return selectedOptions.some((o) => getOptionId(o) === id);
    }, [multiSelect, selectedOptions]);

    /* ── Compose visible list: recent + main, no dupes ─────── */
   
    const { recentShown, mainShown, totalCount } = useMemo(() => {
        const opts = options ?? [];
        const optIds = new Set(opts.map(getOptionId));
        /* Show recent items only if they still exist in `options`.
           This prunes stale references whose underlying record was deleted. */
        const recentValid = recent.filter((r) => optIds.has(getOptionId(r)));
        /* Hide recent items from the main list to avoid dupes */
        const recentIds = new Set(recentValid.map(getOptionId));
        const main = opts.filter((o) => !recentIds.has(getOptionId(o)));
        /* When user is searching, hide the recent section — they're looking
           for something specific, not what they last used. */
        const isSearching = !!searchTerm && searchTerm.trim().length > 0;
        return {
            recentShown: isSearching ? [] : recentValid,
            mainShown:   main,
            totalCount:  (isSearching ? 0 : recentValid.length) + main.length,
        };
    }, [options, recent, searchTerm]);

    /* Flat list for keyboard navigation (recent first, then main) */
    const flatList = useMemo(
        () => [...recentShown, ...mainShown],
        [recentShown, mainShown]
    );

    /* ── Keyboard navigation ───────────────────────────────── */
    const handleKeyDown = (e) => {
        if (!isOpen) return;
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setHighlightIdx((i) => Math.min(i + 1, flatList.length - 1));
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setHighlightIdx((i) => Math.max(i - 1, 0));
        } else if (e.key === 'Enter') {
            e.preventDefault();
            const opt = flatList[highlightIdx];
            if (opt) {
                if (multiSelect) handleMultiSelect(opt);
                else handleSingleSelect(opt);
            }
        } else if (e.key === 'Escape') {
            e.preventDefault();
            setIsOpen(false);
        }
    };

    /* Auto-scroll the highlighted item into view */
    useEffect(() => {
        if (!isOpen || !listRef.current) return;
        const el = listRef.current.querySelector(`[data-row-idx="${highlightIdx}"]`);
        if (el && typeof el.scrollIntoView === 'function') {
            el.scrollIntoView({ block: 'nearest' });
        }
    }, [highlightIdx, isOpen]);

    /* ── Trigger renderers ─────────────────────────────────── */
    const triggerCommon = {
        w: 'full',
        h: '42px',
        px: '12px',
        bg: SURFACE,
        border: '1px solid',
        borderColor: isOpen ? NAVY : BORDER_INPUT,
        borderRadius: '8px',
        fontSize: '13px',
        fontFamily: FONT,
        color: INK,
        cursor: 'pointer',
        textAlign: 'left',
        display: 'flex',
        alignItems: 'center',
        transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
        boxShadow: isOpen ? `0 0 0 3px ${CYAN}` : 'none',
        _hover: { borderColor: isOpen ? NAVY : FAINT },
    };

    const SingleTrigger = (
        <Box
            as="button"
            type="button"
            {...triggerCommon}
            onClick={() => setIsOpen((s) => !s)}
        >
            <Text
                flex="1"
                fontSize="13px"
                fontWeight={selectedOption ? '600' : '400'}
                color={selectedOption ? INK : FAINT}
                noOfLines={1}
            >
                {selectedOption ? getOptionName(selectedOption) : placeholder}
            </Text>
            <Box ml="8px" color={FAINT} transform={isOpen ? 'rotate(180deg)' : 'none'} transition="transform 0.2s">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                    <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </Box>
        </Box>
    );

    const MultiTrigger = (
        <Box
            as="button"
            type="button"
            {...triggerCommon}
            minH="42px"
            h="auto"
            py="6px"
            onClick={() => setIsOpen((s) => !s)}
            flexWrap="wrap"
            gap="4px"
        >
            {selectedOptions.length > 0 ? (
                <Flex flexWrap="wrap" gap="4px" flex="1" align="center">
                    {selectedOptions.map((option) => (
                        <Flex
                            key={getOptionId(option)}
                            align="center"
                            bg={CYAN}
                            border="1px solid"
                            borderColor={`${NAVY}30`}
                            borderRadius="14px"
                            px="8px"
                            py="2px"
                            fontSize="11.5px"
                            color={NAVY}
                            fontWeight="600"
                        >
                            <Text noOfLines={1}>{getOptionName(option)}</Text>
                            <Box
                                as="span"
                                ml="6px"
                                cursor="pointer"
                                onClick={(e) => removeTag(option, e)}
                                w="16px"
                                h="16px"
                                borderRadius="full"
                                display="inline-flex"
                                alignItems="center"
                                justifyContent="center"
                                _hover={{ bg: `${NAVY}20` }}
                                fontSize="13px"
                                lineHeight="1"
                            >
                                ×
                            </Box>
                        </Flex>
                    ))}
                </Flex>
            ) : (
                <Text flex="1" fontSize="13px" color={FAINT}>{placeholder}</Text>
            )}
            <Box ml="8px" color={FAINT} transform={isOpen ? 'rotate(180deg)' : 'none'} transition="transform 0.2s">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                    <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </Box>
        </Box>
    );

    /* ── Row renderer ──────────────────────────────────────── */
    const renderRow = (option, flatIdx) => {
        const id = getOptionId(option);
        const selected = isOptionSelected(option);
        const highlighted = flatIdx === highlightIdx;
        return (
            <Flex
                key={`${id}-${flatIdx}`}
                data-row-idx={flatIdx}
                align="center"
                px="12px"
                py="9px"
                cursor="pointer"
                bg={highlighted ? CYAN : (selected ? SURFACE_ALT : 'transparent')}
                color={INK}
                fontSize="13px"
                fontFamily={FONT}
                fontWeight={selected ? '700' : '500'}
                borderLeft="3px solid"
                borderLeftColor={selected ? NAVY : 'transparent'}
                _hover={{ bg: CYAN }}
                onMouseEnter={() => setHighlightIdx(flatIdx)}
                onClick={() =>
                    multiSelect ? handleMultiSelect(option) : handleSingleSelect(option)
                }
                transition="background 0.1s ease"
            >
                {multiSelect && (                    <Box
                        w="16px"
                        h="16px"
                        borderRadius="4px"
                        border="1.5px solid"
                        borderColor={selected ? NAVY : BORDER_INPUT}
                        bg={selected ? NAVY : SURFACE}
                        mr="10px"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        flexShrink={0}
                    >
                        {selected && (
                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                <path d="M5 12l5 5L20 7" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        )}
                    </Box>
                )}
                <Text noOfLines={1} flex="1">{getOptionName(option)}</Text>
                {!multiSelect && selected && (
                    <Box color={NAVY} ml="6px">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                            <path d="M5 12l5 5L20 7" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Box>
                )}
            </Flex>
        );
    };

    return (
        <Popover
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            placement="bottom-start"
            matchWidth
            gutter={4}
            autoFocus={false}
            returnFocusOnClose={false}
            closeOnBlur={true}
        >
            <PopoverTrigger>
                {multiSelect ? MultiTrigger : SingleTrigger}
            </PopoverTrigger>
            <Portal>
                <PopoverContent
                    bg={SURFACE}
                    border="1px solid"
                    borderColor={BORDER}
                    borderRadius="10px"
                    boxShadow="0 8px 28px rgba(27,59,95,0.14)"
                    overflow="hidden"
                    fontFamily={FONT}
                    w="auto"
                    minW="280px"
                    _focus={{ outline: 'none', boxShadow: '0 8px 28px rgba(27,59,95,0.14)' }}
                >
                    <PopoverBody p="0">
                        {/* Sticky search header */}
                        <Box
                            position="sticky"
                            top="0"
                            bg={SURFACE}
                            borderBottom="1px solid"
                            borderColor={BORDER}
                            p="10px 12px"
                            zIndex={2}
                        >
                            <Flex
                                align="center"
                                bg={SURFACE_ALT}
                                border="1px solid"
                                borderColor={BORDER_INPUT}
                                borderRadius="6px"
                                px="10px"
                                h="34px"
                            >
                                <Box color={FAINT} mr="8px" flexShrink={0}>
                                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                                        <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
                                        <path d="m21 21-4.3-4.3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </Box>
                                <Input
                                    ref={searchInputRef}
                                    variant="unstyled"
                                    fontSize="13px"
                                    color={INK}
                                    fontFamily={FONT}
                                    placeholder={searchPlaceholder}
                                    _placeholder={{ color: FAINT, fontSize: '13px' }}
                                    value={searchTerm ?? ''}
                                    onChange={(e) => setSearchTerm?.(e.target.value)}
                                    onKeyDown={handleKeyDown}
                                />
                                {searchTerm && (
                                    <Box
                                        as="button"
                                        type="button"
                                        color={FAINT}
                                        ml="6px"
                                        fontSize="14px"
                                        lineHeight="1"
                                        flexShrink={0}
                                        _hover={{ color: INK }}
                                        onClick={() => setSearchTerm?.('')}
                                    >
                                        ×
                                    </Box>
                                )}
                            </Flex>
                        </Box>

                        {/* Multi-select actions */}
                        {multiSelect && (options?.length ?? 0) > 0 && (
                            <Flex
                                justify="space-between"
                                align="center"
                                px="12px"
                                py="6px"
                                borderBottom="1px solid"
                                borderColor={BORDER}
                                bg={SURFACE_ALT}
                            >
                                {showSelectAll && (
                                    <Box
                                        as="button"
                                        type="button"
                                        fontSize="11px"
                                        fontWeight="700"
                                        color={NAVY}
                                        fontFamily={FONT}
                                        onClick={handleSelectAll}
                                        _hover={{ textDecoration: 'underline' }}
                                    >
                                        Select all ({options.length})
                                    </Box>
                                )}
                                {showClearAll && selectedOptions.length > 0 && (
                                    <Box
                                        as="button"
                                        type="button"
                                        fontSize="11px"
                                        fontWeight="700"
                                        color={MUTED}
                                        fontFamily={FONT}
                                        onClick={handleClearAll}
                                        _hover={{ color: INK, textDecoration: 'underline' }}
                                    >
                                        Clear all
                                    </Box>
                                )}
                            </Flex>
                        )}

                        {/* Scrollable list */}
                        <Box
                            ref={listRef}
                            maxH={maxHeight}
                            overflowY="auto"
                            sx={{
                                '&::-webkit-scrollbar': { width: '8px' },
                                '&::-webkit-scrollbar-track': { background: SURFACE_ALT },
                                '&::-webkit-scrollbar-thumb': {
                                    background: BORDER_INPUT, borderRadius: '4px',
                                },
                                '&::-webkit-scrollbar-thumb:hover': { background: FAINT },
                            }}
                        >
                            {loading ? (
                                <Flex justify="center" align="center" py="28px">
                                    <Spinner size="sm" color={NAVY} />
                                </Flex>
                            ) : totalCount === 0 ? (
                                <Flex
                                    direction="column"
                                    align="center"
                                    justify="center"
                                    py="28px"
                                    px="16px"
                                    textAlign="center"
                                >
                                    <Text fontSize="12px" fontWeight="700" color={INK} mb="2px">
                                        No matches
                                    </Text>
                                    <Text fontSize="11px" color={FAINT}>
                                        {searchTerm
                                            ? `Nothing found for "${searchTerm}"`
                                            : 'No options available'}
                                    </Text>
                                </Flex>
                            ) : (
                                <>
                                    {/* Recent section */}
                                    {recentShown.length > 0 && (
                                        <>
                                            <Box
                                                px="12px"
                                                py="5px"
                                                fontSize="9.5px"
                                                fontWeight="800"
                                                color={FAINT}
                                                letterSpacing="0.08em"
                                                textTransform="uppercase"
                                                bg={SURFACE_ALT}
                                                borderBottom="1px solid"
                                                borderColor={BORDER}
                                            >
                                                Recently used
                                            </Box>
                                            {recentShown.map((opt, i) => renderRow(opt, i))}
                                            <Box
                                                px="12px"
                                                py="5px"
                                                fontSize="9.5px"
                                                fontWeight="800"
                                                color={FAINT}
                                                letterSpacing="0.08em"
                                                textTransform="uppercase"
                                                bg={SURFACE_ALT}
                                                borderTop="1px solid"
                                                borderBottom="1px solid"
                                                borderColor={BORDER}
                                            >
                                                All {name || 'options'}
                                            </Box>
                                        </>
                                    )}
                                    {mainShown.map((opt, i) =>
                                        renderRow(opt, recentShown.length + i)
                                    )}
                                </>
                            )}
                        </Box>
                    </PopoverBody>
                </PopoverContent>
            </Portal>
        </Popover>
    );
};

export default SearchableSelect;